export default __webpack_public_path__ + "static/media/logo-sigo-trr.7e6c835f.svg";